import { inject, Injectable, Injector } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { AppSessionStorageService } from '../../../services/app-session-storage.service';
import { SessionTabSyncService } from '../../../services/session-tab-sync.service';

@Injectable({
  providedIn: 'root',
})
export class ValidarTokenGuard implements CanActivate, CanLoad {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly sessionStorage = inject(AppSessionStorageService);
  private readonly injector = inject(Injector);

  rute = environment.rute;

  canActivate(): Observable<boolean> | boolean {
    return this.authService.validarToken().pipe(
      tap(resp => {
        if (!resp) {
          this.notAuthorized();
        }
      })
    );
  }

  canLoad(): Observable<boolean> | boolean {
    return this.authService.validarToken().pipe(
      tap(resp => {
        if (!resp) {
          this.notAuthorized();
        }
      })
    );
  }

  private notAuthorized() {
    this.sessionStorage.notifyLogout();
    this.injector.get(SessionTabSyncService).clearLocalSessionState();
    this.sessionStorage.clearSession();
    this.router.navigate(['/login']);
  }
}
